<template lang="html">
  <div class="full-page">
    <i-header title="投资者基本信息" @leftClick="$_headerLeftClick">
      <span slot="left"><i class="cubeic-back"></i></span>
    </i-header>
    <i-body>
      <cube-form
        class="form-custom"
        :model="Model"
        :options="options">
        <cube-form-group legend="基本信息">
            <cube-form-item :field="fields[0]"></cube-form-item>
            <cube-form-item :field="fields[1]">
              <div style="text-align:right;">
                {{$_iDCardTypesLabel(Model.catType)}}
              </div>
            </cube-form-item>
            <cube-form-item :field="fields[2]"></cube-form-item>
            <cube-form-item :field="fields[3]"></cube-form-item>
          </cube-form-group>

          <cube-form-group legend="">
            <cube-form-item :field="fields[4]"></cube-form-item>
            <cube-form-item :field="fields[5]"></cube-form-item>
            <cube-form-item v-if="$_isForeign(Model.catType)" :field="fields[6]"></cube-form-item>
          </cube-form-group>

          <cube-form-group legend=" ">
            <cube-form-item :field="fields[7]"></cube-form-item>
            <!-- <cube-form-item v-if="Model.userOccupation === '自定义'" :field="fields[16]"></cube-form-item> -->
            <cube-form-item :field="fields[8]"></cube-form-item>
            <cube-form-item :field="fields[9]"></cube-form-item>
            <cube-form-item :field="fields[10]"></cube-form-item>
            <cube-form-item :field="fields[11]"></cube-form-item>
          </cube-form-group>

          <cube-form-group legend="">
            <cube-form-item :field="fields[12]"></cube-form-item>
            <cube-form-item :field="fields[13]"></cube-form-item>
          </cube-form-group>
      </cube-form>
    </i-body>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import mixin from '../config/viewConfig';
import cmixin from '../../commonConfig';

export default {
  name: 'view-base-info',
  mixins: [mixin, cmixin],
  computed: {
    ...mapGetters(['managerInfo', 'au']),
  },
  mounted() {
    setTimeout(() => {
      this.$bridge.callHandler('getBaseInfo', { msg: '获取投资者基本信息' }, (data) => {
        const obj = JSON.parse(data);
        console.log('详情1', obj.baseInfo);
        this.$_handlerInit(obj.baseInfo);
      });
    }, 300);
  },
  methods: {
    /**
     * 初始数据
     * @param  {[type]} data [description]
     * @return {[type]}      [description]
     */
    $_handlerInit(data) {
      const obj = JSON.parse(data);
      obj.catType = this.$_formatOldCatType(obj.catType);
      obj.userCountry = obj.userCountry || '中国'; // 默认 中国
      Object.keys(this.Model).forEach((key) => {
        this.Model[key] = obj[key];
      });
      // 老数据没有 有效期这个字段，需要用“-” 替换
      this.$set(this.Model, 'documentsValidity', obj.documentsValidity || '-');
      console.log('view', obj.documentsValidity);
    },
  },
};
</script>
